import React, { Component } from 'react';
import { get } from 'lodash';
import { string } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { Heading, Text, Box } from '@landtrustinc/design-system';
import { propTypes } from '../../util/types';
import { obfuscatedCoordinates } from '../../util/maps';
import { Map } from '../../components';
import config from '../../config';

import css from './ListingPage.module.css';

class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    this.state = { isStatic: true };
  }

  render() {
    const { className, rootClassName, geolocation, publicData, listingId } = this.props;
    const { isStatic } = this.state;

    if (!geolocation) {
      return null;
    }

    const address = publicData && publicData.location ? publicData.location.address : '';
    const classes = classNames(rootClassName || css.sectionMap, className);
    const cacheKey = listingId ? `${listingId.uuid}_${geolocation.lat}_${geolocation.lng}` : null;
    const nearestTown = get(publicData, 'nearestTown.selectedPlace.address', null);

    const mapProps = config.maps.fuzzy.enabled
      ? { obfuscatedCenter: obfuscatedCoordinates(geolocation, cacheKey) }
      : { address, center: geolocation };
    const map = <Map {...mapProps} useStaticMap={isStatic} />;

    return (
      <div className={classes} id="listingMap">
        <Box display="flex" flexDirection="column" gap="var(--spacing-1)">
          <Heading size="2xs" color="var(--text-primary)" fontWeight="bold">
            <FormattedMessage id="ListingPage.locationTitle" />
          </Heading>

          {nearestTown && <Text>{nearestTown}</Text>}
        </Box>

        <div className={css.mapWrapper}>
          {isStatic ? (
            <button
              type="button"
              className={css.map}
              onClick={() => {
                this.setState({ isStatic: false });
              }}
            >
              {map}
            </button>
          ) : (
            <div className={css.map}>{map}</div>
          )}
        </div>
      </div>
    );
  }
}

SectionMapMaybe.defaultProps = {
  rootClassName: null,
  className: null,
  geolocation: null,
  listingId: null,
};

SectionMapMaybe.propTypes = {
  rootClassName: string,
  className: string,
  geolocation: propTypes.latlng,
  listingId: propTypes.uuid,
};

export default SectionMapMaybe;
